import DatePickerLibrary from 'react-datepicker';

import type { FunctionComponent } from 'react';
import type { TypeDatePickerProps } from './types';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './DatePicker.module.css';

/**
 * DatePicker
 */
export const DatePicker: FunctionComponent<TypeDatePickerProps> = ({
  className = '',
  ...props
}: TypeDatePickerProps) => (
  <div className={styles['date-picker']}>
    <DatePickerLibrary
      className={`text-body--primary font-thin text-text-primary ${className}`}
      {...props}
    />
  </div>
);

DatePicker.displayName = 'DatePicker';
